// types
import { PlanningEntityType } from 'generated/index';

export const supportedPlanningEntityTypes: PlanningEntityType[] = [
  'CLIENT',
  'EMPLOYEE',
  'WORKPLACE',
  'RESOURCE'
];
